module.exports = __webpack_public_path__ + "static/media/b.bb9fc011.gif";